import { render, staticRenderFns } from "./VenueRoomDetails.vue?vue&type=template&id=5f681752&"
import script from "./VenueRoomDetails.vue?vue&type=script&lang=js&"
export * from "./VenueRoomDetails.vue?vue&type=script&lang=js&"
import style0 from "./VenueRoomDetails.vue?vue&type=style&index=0&id=5f681752&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports